import { c as _c } from "react/compiler-runtime";
import { stringify } from 'betterplace-utils';
import styles from './JSONPrettyPrint.module.css';
import { JSONPrettyPrintProps, Printable } from './types';
function syntaxHighlight(json: string) {
  json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g, match => {
    let cls = styles.number;
    if (/^"/.test(match)) {
      if (/:$/.test(match)) {
        cls = styles.key;
      } else {
        cls = styles.string;
      }
    } else if (/true|false/.test(match)) {
      cls = styles.boolean;
    } else if (/null/.test(match)) {
      cls = styles.null;
    }
    cls ??= '';
    return `<span class='${cls}'>${match}</span>`;
  });
}
function JSONPrettyPrint(t0) {
  const $ = _c(6);
  const {
    json
  } = t0;
  let t1;
  if ($[0] !== json) {
    t1 = typeof json === "string" ? json : stringify(json, 2);
    $[0] = json;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const jsonStr = t1;
  let t2;
  if ($[2] !== jsonStr) {
    t2 = syntaxHighlight(jsonStr);
    $[2] = jsonStr;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const output = t2;
  let t3;
  if ($[4] !== output) {
    t3 = <div className={styles.JSONPrettyPrintMain}><pre dangerouslySetInnerHTML={{
        __html: output
      }} /></div>;
    $[4] = output;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
export default JSONPrettyPrint;